import { useState } from 'react';
import type { SandboxShipParams } from '../../../lib/api/operatorConsole';
import { Button } from '../../../components/ui/Button';

interface Props {
  busy: boolean;
  onSubmit: (params: SandboxShipParams) => void;
  onClose: () => void;
}

const fieldClass =
  'rounded-md border border-ui-border bg-ui-card px-3 py-2 text-sm text-ui-text ' +
  'placeholder:text-ui-text-secondary focus:outline-none focus:ring-2 focus:ring-[var(--co-brand)]';

// Both fields are optional, like at our warehouse: shipping.shipped simply
// carries nulls when nothing was typed.
export function ShipForm({ busy, onSubmit, onClose }: Props) {
  const [carrier, setCarrier] = useState('');
  const [tracking, setTracking] = useState('');

  return (
    <li>
      <form
        aria-label="Ship this delivery"
        className="flex flex-wrap items-end gap-3 rounded-md border border-ui-border p-3"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit({ company_name: carrier.trim(), tracking_number: tracking.trim() });
        }}
      >
        <label className="flex flex-col gap-1 text-[12px] text-ui-text-secondary">
          Carrier (optional)
          <input
            className={`${fieldClass} w-40`}
            value={carrier}
            onChange={(event) => setCarrier(event.target.value)}
            placeholder="e.g. USPS"
          />
        </label>
        <label className="flex flex-col gap-1 text-[12px] text-ui-text-secondary">
          Tracking number (optional)
          <input
            className={`${fieldClass} w-56`}
            value={tracking}
            onChange={(event) => setTracking(event.target.value)}
            placeholder="Any test number"
          />
        </label>
        <Button type="submit" className="px-3 py-2" disabled={busy}>
          Ship delivery
        </Button>
        <Button type="button" variant="ghost" className="px-3 py-2" onClick={onClose}>
          Close
        </Button>
      </form>
    </li>
  );
}
